/* eslint-disable no-return-assign */
import React, { PureComponent } from 'react';
import throttle from 'lodash/throttle';
import moment from 'moment';
import { LayoutWithStepper } from 'layouts';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  applicantAction, stepAction, agreementAction,
} from 'shared/store/actions';

import { isMobileOnly } from 'react-device-detect';

// import { Document, Page } from 'react-pdf';
import { Document, Page } from 'react-pdf/dist/entry.webpack';
import {
  PATH,
  CLIENT_CLASSIFICATION
} from 'shared/constant';

import {
  FooterAction, PageContentWrapper, Modal,
} from 'components';
import selectors from 'shared/store/selectors';
// import axios from 'axios';
import { SubPageMenu, PdfLoader } from './components';

import 'react-pdf/dist/Page/AnnotationLayer.css';

// let source = axios.CancelToken.source();
class Preview extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      numPages: null,
      width: null,
      // currentSubPage: process.env.NODE_ENV === 'production' ? window.location.pathname.split('/')[2] : window.location.pathname.split('/')[3],
      currentSubPage: 'crm',
      isIdModalWarningOpen: false,
    };
    // source = axios.CancelToken.source();
  }
  // state = {
  //   numPages: null,
  //   width: null,
  //   // currentSubPage: process.env.NODE_ENV === 'production' ? window.location.pathname.split('/')[2] : window.location.pathname.split('/')[3],
  //   currentSubPage: 'crm',
  //   isIdModalWarningOpen: false,
  // };

  componentDidMount() {
    const {
      match: { params },
      // onUpdateSteps, intl,
      onUpdateCurrentStep,
      onGetApplicantPdf, onGetFatcaPDF, onGetCrsPDF, onGetTCPDF,
      isAllStepsCompleted, history,
      formSignature,
      clientClassification,
      isAgreementReadyForQualified,
      onGetAgreementStatus, onSaveApplicant,
    } = this.props;

    // if (isMobile && process.env.NODE_ENV === 'production') this.setState({ currentSubPage: window.location.pathname.split('/')[3] });

    // SIGNATURE TIMESTAMP
    const timestamp = moment().unix();
    const timestampUTC = moment().utcOffset();
    this.props.onUpdateTimestamp(timestamp, timestampUTC);
    this.props.onUpdateTimestamp2ndAgreement(timestamp, timestampUTC);
    onSaveApplicant(true).then((res) => {
      onGetAgreementStatus();

      if (formSignature && clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && !isAgreementReadyForQualified) history.push(PATH.QUALIFIED_CONFIRMATION);
      if (formSignature && isAgreementReadyForQualified) history.push(PATH.AGREEMENT);

      // console.log('params id', params.id);
      if (params.id && res) {
        onGetFatcaPDF();
        onGetCrsPDF();
        onGetTCPDF();
        onGetApplicantPdf(false);
      }
    });
    // switch (params.id) {
    //   case 'fatca':
    //     onGetFatcaPDF();
    //     break;
    //   case 'crs':
    //     onGetCrsPDF();
    //     break;
    //   case 't&c':
    //     onGetTCPDF();
    //     break;
    //   default:
    //     onGetApplicantPdf(false);
    // }

    /** Redirect to Homepage if all steps are completed else update steps */
    if (isAllStepsCompleted) {
      history.push(PATH.HOME);
    } else {
      onUpdateCurrentStep('step5');
      // onUpdateSteps(intl);
    }

    /** Calculate the device width */
    this.setDivSize();
    window.addEventListener('resize', throttle(this.setDivSize, 500));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', throttle(this.setDivSize, 500));

    // if (source) {
    //   source.cancel('cancel lah!');
    // }
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  }

  setDivSize = () => {
    if (this.pdfWrapper && this.pdfWrapper.getBoundingClientRect()) {
      this.setState({ width: this.pdfWrapper.getBoundingClientRect().width });
    }
  }

  onHandleMenuClick = (id) => {
    // const { history } = this.props;
    // history.push(`${PATH.PREVIEW}/${id}`);
    this.setState({ currentSubPage: id });
  }

  render() {
    const {
      history, intl, crmUrl, fatcaUrl, crsUrl, tcUrl,
      isClientIdsCompleted, tobeEmailed,
    } = this.props;
    const {
      numPages, width, currentSubPage, isIdModalWarningOpen,
    } = this.state;

    /** Get pdf url based on state change */
    const fileUrl = () => {
      // console.log('currentSubPage', currentSubPage);
      switch (currentSubPage) {
        case 'fatca':
          return fatcaUrl;
        case 'crs':
          return crsUrl;
        case 't&c':
          return tcUrl;
        default:
          return crmUrl;
      }
    };

    const footer = (
      <FooterAction
        isSingleButton
        isTranslate
        rightButton="continue"
        onRightButtonClick={() => {
          if (!isClientIdsCompleted && tobeEmailed !== 'tobeEmailed') {
            // Call Modal here
            this.setState({ isIdModalWarningOpen: true });
          } else {
            history.push(PATH.FORM_AGREEMENTS);
          }
        }}
      />
    );

    return (
      <>
        <PageContentWrapper isWithHeader>
          <div className="content-container content-container--reader">
            <SubPageMenu defaultMenu={currentSubPage} title="previewForm" onClick={e => this.onHandleMenuClick(e)} />

            <section className="pdf-wrapper" ref={ref => this.pdfWrapper = ref} style={{ margin: isMobileOnly ? '10px' : '25px' }}>
              {/* @Todo: Add PDF viewer here */}
              <Document
                file={fileUrl()}
                onLoadSuccess={this.onDocumentLoadSuccess}
                padding={isMobileOnly ? 20 : 50}
                error={intl.formatMessage({ id: 'preview.error' })}
                // noData={formatMessage({ id: 'preview.error' })}
                loading={(<PdfLoader />)}
                noData={(<PdfLoader />)}
              >
                {
                Array.from(
                  new Array(numPages),
                  (el, index) => (<Page key={`page_${index + 1}`} pageNumber={index + 1} width={width} />),
                )
              }
              </Document>
            </section>
          </div>
          {!isMobileOnly && footer}

          {/* Modal Warning for Incomplete Ids */}
          <Modal
            withPadding
            isWarning
            showModal={isIdModalWarningOpen}
            title={<FormattedMessage id="modal.idUpload.title" />}
            onClose={() => {
              this.setState({ isIdModalWarningOpen: false });
              history.push({
                pathname: PATH.ID_PASSPORT_SCANNING,
                state: {
                  fromPreview: true,
                },
              });
            }}
          >
            <FormattedHTMLMessage id="modal.idUpload.desc" />
          </Modal>
        </PageContentWrapper>
        {isMobileOnly && footer}
      </>
    );
  }
}

const mapStateToProps = state => ({
  crmUrl: state.applicantRootReducer.applicantReducer.crmUrl,
  fatcaUrl: state.applicantRootReducer.applicantReducer.fatcaUrl,
  crsUrl: state.applicantRootReducer.applicantReducer.crsUrl,
  tcUrl: state.applicantRootReducer.applicantReducer.tcUrl,
  isAllStepsCompleted: selectors.isAllStepsCompleted(state),
  formSignature: selectors.getAofKycProfileSignature(state),
  clientClassification: selectors.getClientClassification(state),
  isAgreementReadyForQualified: selectors.getIsAgreementReadyStatus(state),
  isClientIdsCompleted: selectors.isIdsUploaded(state),
  tobeEmailed: selectors.getIsTobeEmailed(state),
});

const mapDispatchToProps = dispatch => ({
  onGetApplicantPdf: isGetAll => dispatch(applicantAction.getApplicantPdf(isGetAll)),
  onGetFatcaPDF: () => dispatch(applicantAction.getFatcaPdf()),
  onGetCrsPDF: () => dispatch(applicantAction.getCrsPdf()),
  onGetTCPDF: () => dispatch(applicantAction.getTCPdf()),
  onUpdateCurrentStep: currentStep => dispatch(stepAction.updateCurrentStep(currentStep)),
  onUpdateSteps: intl => dispatch(stepAction.updateSteps(intl)),
  onGetAgreementStatus: () => dispatch(agreementAction.getQualifiedAgreementStatus()),
  onUpdateTimestamp: (timestamp, timestampUTC) => dispatch(agreementAction.updateAofKycProfileTimestamp(timestamp, timestampUTC)),
  onUpdateTimestamp2ndAgreement: (timestamp, timestampUTC) => dispatch(agreementAction.updateNdpfProposedPlanTimestamp(timestamp, timestampUTC)),
  onSaveApplicant: isGenerate => dispatch(applicantAction.updateApplicant(isGenerate)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithStepper(injectIntl(Preview)));
